export default {
    'lbl_0000001': 'Forgot Password',
    'lbl_0000002': 'Verify your account',
    'lbl_0000003': 'It seems that you have forgotten your password. Please verify your identity by entering the One-Time Password (OTP) we will be sending to your email address or mobile number.',
    'lbl_0000004': 'Continue',
    'lbl_0000005': 'Email Address',
    'lbl_0000006': 'Not Me',
    'lbl_0000007': 'Mobile No.',
    'lbl_0000008': 'Untitled Page',
    'lbl_0000009': 'Send OTP',
    'lbl_0000010': 'Are you sure you want to proceed?',
    'lbl_0000011': 'Find your account',	
    'lbl_0000012': 'Please enter either your account number, serial number, username, email address, or mobile number to find your account.',
    'lbl_0000013': 'Verification',
    'lbl_0000014': 'Create an account',
    'lbl_0000015': 'Proceed',
    'lbl_0000016': 'Verify',
    'lbl_0000017': 'Clear',
    'lbl_0000018': 'Resend Code',
    'lbl_0000019': 'Resend code in',
    'lbl_0000020': 'To ensure the security of your account, we need to verify your mobile number and email address.',
    'lbl_1000020': 'Click on \'Mobile No.\' and \'Email Address\' to start the verification process.',
    'lbl_0000021': 'Mobile No.',
    'lbl_0000022': 'Email Address',
    'lbl_0000023': 'Verify Mobile No.',
    'lbl_0000024': 'A One-Time Password (OTP) has been sent to your registered mobile number.',
    'lbl_1000024': 'Please check your messages and enter the OTP to proceed.',
    'lbl_0000025': 'Error',
    'lbl_0000026': 'Mobile number has been successfully verified.',
    'lbl_0000027': 'Verified',
    'lbl_0000028': 'Verify Email Address',
    'lbl_0000029': 'A One-Time Password (OTP) has been sent to your registered email address.',
    'lbl_1000029': 'Please check your inbox and enter the OTP to proceed.',
    'lbl_0000030': 'Enroll PIN',
    'lbl_0000031': 'To keep your account secure, please enroll a 6-digit Personal Identification Number (PIN).',
    'lbl_1000031': 'For verification purposes, please re-enter your PIN.',
    'lbl_0000032': 'PIN',
    'lbl_0000033': 'Next',
    'lbl_0000034': 'Oops!',
    'lbl_0000035': 'Confirm PIN',
    'lbl_0000036': 'The PINs you entered do not match.',
    'lbl_0000037': 'Welcome, Ka-May-Ari!',
    'lbl_0000038': 'Your account has been successfully created.',
    'lbl_0000039': 'Get Started',
    'lbl_0000040': 'Hello',
    'lbl_0000041': 'Username',
    'lbl_0000042': 'Password',
    'lbl_0000043': 'Log In',
    'lbl_0000044': 'version',
    'lbl_0000045': 'Something went wrong.',
    'lbl_0000046': 'Please enter the One-Time Password (OTP) sent to your registered email address or mobile number to proceed with updating your password.',
    'lbl_0000047': 'New Password',
    'lbl_0000048': 'Confirm Password',
    'lbl_0000049': 'Update Password',
    'lbl_0000050': 'Update',
    'lbl_0000051': 'Your password has been updated successfully.',
    'lbl_0000052': 'Updated Successfully',
    'lbl_0000053': 'Username must be at least six (6) characters and cannot contain spaces or special characters.',
    'lbl_0000054': 'Edit Username',
    'lbl_0000055': 'Session has expired.',
    'lbl_0000056': 'Discard Changes',
    'lbl_0000057': 'Do you want to discard all changes?',
    'lbl_0000058': 'Success',
    'lbl_0000059': 'Username has been successfully saved.',
    'lbl_0000060': 'Your password must be at least eight (8) characters long and include uppercase and lowercase letters, a number, and a special character.',
    'lbl_0000061': 'Old Password',
    'lbl_0000062': 'New Password',
    'lbl_0000063': 'Confirm Password',
    'lbl_0000064': 'Edit Password',
    'lbl_0000065': 'Password has been successfully saved.',
    'lbl_0000066': 'Edit TIN',
    'lbl_0000067': 'Government ID',
    'lbl_0000068': 'TIN has been successfully saved.',
    'lbl_0000069': 'Deactivate Account',
    'lbl_0000070': 'We\'re sorry to see you go. Deactivating your account will temporarily disable your access to your profile, and you will not be able to access your account again until it is reactivated.',
    'lbl_0000071': 'We have sent a One-Time Password (OTP) to your mobile number or email address to continue deactivating your account.',
    'lbl_0000072': 'Edit Mobile',
    'lbl_0000073': 'Please enter the One-Time Password (OTP) sent to your mobile number.',
    'lbl_0000074': 'Mobile number has been successfully updated.',
    'lbl_0000075': 'Edit Email Address',
    'lbl_0000076': 'Please enter the One-Time Password (OTP) sent to your email address.',
    'lbl_0000077': 'Email address has been successfully updated.',
    'lbl_0000078': 'Account',
    'lbl_0000079': 'Contacts',
    'lbl_0000080': 'Security',
    'lbl_0000081': 'Member Info',
    'lbl_0000082': 'Authentication',
    'lbl_0000083': 'Home',
    'lbl_0000084': 'Profile',
    'lbl_0000085': 'Settings',
    'lbl_0000086': 'Help',
    'lbl_0000087': 'Edit PIN',
    'lbl_0000088': 'Old PIN',
    'lbl_0000089': 'New PIN',
    'lbl_0000090': 'Confirm PIN',
    'lbl_0000091': 'PIN has been successfully updated.',
    'lbl_0000092': 'The PIN you entered does not match. Please try again.',
    'lbl_0000093': 'Account No.',
    'lbl_0000094': 'Serial No.',
    'lbl_0000095': 'Regular',
    'lbl_0000096': 'Associate',
    'lbl_0000097': 'Basic Info',
    'lbl_0000098': 'TIN',
    'lbl_0000099': 'Registered',
    'lbl_0000100': 'Others',
    'lbl_0000101': 'Account',
    'lbl_0000102': 'Membership Type',
    'lbl_0000103': 'Age',
    'lbl_0000104': 'Gender',
    'lbl_0000105': 'Date of Birth',
    'lbl_0000106': 'QR Code',
    'lbl_0000107': 'Authentication Settings',
    'lbl_0000108': 'Login Automatically',
    'lbl_0000109': 'Keep current session in this device.',
    'lbl_0000110': 'One-Time Password (OTP)',
    'lbl_0000111': 'Require OTP to complete the login process',
    'lbl_0000112': 'Election is officially closed.',
    'lbl_0000113': 'Register',
    'lbl_0000114': 'Days',
    'lbl_0000115': 'Hrs',
    'lbl_0000116': 'Mins',
    'lbl_0000117': 'Secs',
    'lbl_0000118': 'Registration starts in',
    'lbl_0000119': 'Voting starts in',
    'lbl_0000120': 'Voting ends in',
    'lbl_0000121': 'Vote Now',
    'lbl_0000122': 'Are you sure you want to register?',
    'lbl_0000123': 'Log Out',
    'lbl_0000124': 'Are you sure you want to log out?',
    'lbl_0000125': 'Our Company',
    'lbl_0000126': 'Satellite Offices',
    'lbl_0000127': 'Luzon',
    'lbl_0000128': 'Visayas',
    'lbl_0000129': 'Mindanao',
    'lbl_0000130': 'Help Center',
    'lbl_0000131': 'Help & Support',
    'lbl_0000132': 'Contact Us',
    'lbl_0000133': 'End-User License Agreement',
    'lbl_0000134': 'Terms and Policies',
    'lbl_0000135': 'Privacy Policy',
    'lbl_0000136': 'Not Found',
    'lbl_0000137': 'By clicking \'Leave\', your account will be deactivated and you will be logged out. You will not be able to access your account again until it is reactivated.',
    'lbl_0000138': 'Confirm Deactivation',
    'lbl_0000139': 'Leave',
    'lbl_0000140': 'Deactivate',
    'lbl_0000141': 'Welcome, Ka-May-Ari!',
    'lbl_0000142': 'Serving the AFP since 1981',
    'lbl_0000143': 'Sign Up',
    'lbl_0000144': 'Need Help?',
    'lbl_0000145': 'Last Name',
    'lbl_0000146': 'First Name',
    'lbl_0000147': 'I agree with the',
    'lbl_0000148': 'Join',
    'lbl_0000149': 'Reactivate Account',
    'lbl_0000150': 'Please verify if your contact information is correct to continue reactivating your account.',
    'lbl_0000151': 'Activate',
    'lbl_0000152': 'Please enter the One-Time Password (OTP) sent to your registered email address or mobile number to proceed with reactivating your account.',
    'lbl_0000153': 'Save',
    'lbl_0000154': 'You have successfully enrolled your PIN.',
    'lbl_0000155': 'Schedules',
    'lbl_0000156': 'Registration',
    'lbl_0000157': 'To',
    'lbl_0000158': 'Voting',
    'lbl_0000159': 'Please enter a new PIN.',
    'lbl_0000160': 'Remember to keep your password secure and avoid sharing it with others.',
    'lbl_0000161': 'Registration ends in',
    'lbl_0000162': 'You have already registered',
    'lbl_0000163': 'Election',
    'lbl_0000164': 'You have already voted.',
    'lbl_0000165': 'Election OTP',
    'lbl_0000166': 'Enter the One-Time Password (OTP) sent to your mobile number or email address.',
    'lbl_0000167': 'Election Policy',
    'lbl_0000168': 'Scroll down at the bottom of the page to proceed in voting.',
    'lbl_0000169': 'Board of Directors',
    'lbl_0000170': 'Please select Seven (7) Candidates for the Board of Directors Position - At-Large Category.',
    'lbl_0000171': 'My Current Votes',
    'lbl_0000172': 'Board of Directors',
    'lbl_0000173': 'Election Committee',
    'lbl_0000174': 'Officer',
    'lbl_0000175': 'Enlisted Personnel',
    'lbl_0000176': 'Audit Committee',
    'lbl_0000177': 'Please finish voting first before leaving.',
    'lbl_0000178': 'You cannot go back until you have selected the required number of votes for this category.',
    'lbl_0000179': 'Are you sure you want to clear all selected candidates?',
    'lbl_0000180': 'You have already selected the maximum number of candidates. Please deselect a candidate to select again.',
    'lbl_0000181': 'Back',
    'lbl_0000182': 'Reminder',
    'lbl_0000183': 'At-Large Category',
    'lbl_0000184': 'No candidate selected.',
    'lbl_0000185': 'Please select one (1) Candidate for the Audit Committee Position.',
    'lbl_0000186': 'Please select one (1) Candidate for the Election Committee Position - Officer Category.',
    'lbl_0000187': 'Please select one (1) Candidate for the Election Committee Position - Enlisted Personnel Category.',
    'lbl_0000188': 'Please check the names below before submitting your votes.',
    'lbl_0000189': 'Vote Summary',
    'lbl_0000190': 'Submit',
    'lbl_0000191': 'No Category',
    'lbl_0000192': 'Vote',
    'lbl_0000193': 'Are you sure you want to submit your votes?',
    'lbl_0000194': 'Philippine Army Finance Center Producers Integrated Cooperative',
    'lbl_0000195': 'Summary of Votes',
    'lbl_0000196': 'Ballot No.',
    'lbl_0000197': 'Name',
    'lbl_0000198': 'Number of Votes',
    'lbl_0000199': 'Skip',
    'lbl_0000200': 'or',
    'lbl_0000201': 'Thank You!',
    'lbl_0000202': 'How do you feel about this election?',
    'lbl_0000203': 'Needs Improvement',
    'lbl_0000204': 'Below Average',
    'lbl_0000205': 'Average',
    'lbl_0000206': 'Good',
    'lbl_0000207': 'Excellent',
    'lbl_0000208': 'Vote Limit Reached',
    'lbl_0000209': 'OTP',
    'lbl_0000210': 'Started:',
    'lbl_0000211': 'Submitted',
    'lbl_0000212': 'Thank you for voting!',
    'lbl_0000213': 'Voting is officially closed.',
    'lbl_0000214': 'Please wait',
    'lbl_0000215': 'Voting starts on',
    'lbl_0000216': 'Voting ends on',
    'lbl_0000217': 'Your vote was successfully recorded.',
    'lbl_0000218': 'How would you rate your voting experience?',
    'lbl_0000219': 'Thank you for voting!',
    'lbl_0000220': 'Approve',
    'lbl_0000221': 'Disapprove',
    'lbl_0000222': 'Are you sure you want to submit your vote?',
    'lbl_0000223': 'Once submitted, your vote cannot be changed or resubmitted.',
    'lbl_0000224': 'Submit Vote',
    'lbl_0000225': 'Voting Successful',
    'lbl_0000226': 'Rate Us',
    'lbl_0000227': 'Connectivity',
    'lbl_0000228': 'Accuracy',
    'lbl_0000229': 'Convenience',
    'lbl_0000230': 'Reliability',
    'lbl_0000231': 'Ease of Use',
    'lbl_0000232': 'Security',
    'lbl_0000233': 'Accessibility',
    'lbl_0000234': 'Yay! Let us know what you liked',
    'lbl_0000235': 'What can be improved?',
    'lbl_0000236': 'Please make changes to your password.',
    'lbl_0000237': 'Passwords do not match.',
    'lbl_0000238': 'Either an account number or a serial number is required.',
    'lbl_0000239': 'Email address is already taken.',
    'lbl_0000240': 'Please input a valid mobile number.',
    'lbl_0000241': 'Username is already taken.',
    'lbl_0000242': 'Please input a valid email address.',
    'lbl_0000243': 'Username is too short.',
    'lbl_0000244': 'Confirm your information',
    'lbl_0000245': 'Make sure all details are correct. Please review your information before submitting.',
    'lbl_0000246': 'Edit',
    'lbl_0000247': 'Invalid Account No.',
    'lbl_0000248': 'Invalid Serial No.',
    'lbl_0000249': 'Mobile number is already taken.',
    'lbl_0000250': 'You are not entitled to vote.',
    'lbl_0000251': 'Get Started',
    'lbl_0000252': 'Return Home',
    'lbl_0000253': 'Page Not Found',
    'lbl_0000254': '404',
    'lbl_0000255': 'Personal Information',
    'lbl_0000256': 'You can only edit your TIN once.',
    'lbl_0000257': 'See our',
    'lbl_0000258': 'to learn how we handle your data.',
    'lbl_0000259': 'You can only edit your date of birth once.',
    'lbl_0000260': 'Edit Date of Birth',
    'lbl_0000261': 'Date of birth has been successfully saved',
    'lbl_0000262': 'Please enter your PIN to continue deactivating your account.',
    'lbl_0000263': 'By clicking',
    'lbl_0000264': ', your account will be deactivated and you will be logged out.',
    'lbl_0000265': 'You will not be able to access your account again until it is reactivated.',
    'lbl_0000266': 'Confirm',
    'lbl_0000267': 'We have detected that your account does not have an email address. Please enroll your email address to help keep your account secure.',
    'lbl_0000268': 'Enroll Email Address',
    'lbl_0000269': 'We have detected that your account does not have a mobile number. Please enroll your mobile number to help keep your account secure.',
    'lbl_0000270': 'Enroll Mobile No.',
    'lbl_0000271': 'Easily access essential PAFCPIC services and information in just a few taps.',
    'lbl_0000272': 'We have noticed that some of your personal information is missing from your account. Please provide your information to help keep your account secure.',
    'lbl_0000273': 'Update Information',
    'lbl_0000274': 'To-do',
    'lbl_0000275': 'Enroll Date of Birth',
    'lbl_0000276': 'Enroll TIN',
    'lbl_0000277': 'You\'re all set! Your account information has been successfully saved.',
    'lbl_0000278': 'Mobile number has been successfully saved.',
    'lbl_0000279': 'Email address has been successfully saved.',
    'lbl_0000280': 'Please enter your PIN to continue logging in to your account.',
    'lbl_0000281': 'Enter PIN',
    'lbl_0000282': 'Enter OTP',
    'lbl_0000283': 'Please enter the One-Time Password (OTP) sent to your registered email address or mobile number to continue with logging in to your account.',
    'lbl_0000284': 'You have successfully logged in using a temporary Personal Identification Number (PIN). To ensure the security of your account, please update your PIN.',
    'lbl_0000285': 'Please make changes to your PIN.',
    'lbl_0000286': 'Forgot PIN',
    'lbl_0000287': 'Please enter the One-Time Password (OTP) sent to your registered email address or mobile number to continue with resetting your PIN.',
    'lbl_0000288': 'Please enter your new PIN to continue with logging in to your account.',
    'lbl_0000289': 'Reset PIN',
    'lbl_0000290': 'Thank you for registering for the Referendum!',
    'lbl_0000291': 'Enroll Information',
    'lbl_0000292': 'Use a different email address',
    'lbl_0000293': 'Use a different mobile number',
    'lbl_0000294': 'Enroll',
    'lbl_0000295': 'You have successfully reset your PIN.',
    'lbl_0000296': 'Services',
    'lbl_0000297': 'Electronic Fund Transfer',
    'lbl_0000298': 'Philippine National Bank (PNB)',
    'lbl_0000299': 'Subscribe',
    'lbl_0000300': 'Receive funds directly to your PNB account.',
    'lbl_0000301': 'Terms and Conditions',
    'lbl_0000302': 'I Agree',
    'lbl_0000303': 'Subscribe',
    'lbl_0000304': 'Receive your PatRef/Dividend directly to your bank account for FREE!',
    'lbl_0000305': 'No registered bank accounts found.',
    'lbl_0000306': 'Your EFT subscription updates have been successfully saved!',
    'lbl_0000307': 'Save Changes',
    'lbl_0000308': 'Subscribe to all',
    'lbl_0000309': 'More Details',
    'lbl_0000310': 'Please enter your PIN to confirm your subscription.',
    'lbl_0000311': 'Unsubscribe to all',
    'lbl_0000312': 'No bank account is enrolled under your PAFCPIC Account.',
    'lbl_0000313': 'Right now, only PNB accounts opened through PSOs are supported. For members who opened their PNB accounts through other channels, please stay tuned—your accounts will be included in the next phase of our system integration. If you haven\'t opened your PNB account yet, please visit your nearest PSO to apply while cards are still free.',
    'lbl_0000314': 'PAPSI RUN: #FortyFOURWARDofHOPE',
    'lbl_0000315': 'Register',
    'lbl_0000316': 'Fun Run Registration',
    'lbl_0000317': 'Join us for PAPSI Run: #FortyFOURWARDofHOPE as we celebrate PAFCPIC\'s 44th Anniversary on November 15, 2025, at the Philippine Army Grandstand, Fort Bonifacio.',
    'lbl_0000318': 'Please select a valid option.',
    'lbl_0000319': 'I consent to the use of my photos and videos in PAFCPIC\'s promotional materials and activities.',
    'lbl_0000320': 'Add Registrant',
    'lbl_0000321': 'Please complete all registrant details.',
    'lbl_0000322': 'Registrant #',
    'lbl_0000323': 'Safety and Security Reminders',
    'lbl_0000324': 'Photo and Video Consent',
    'lbl_0000325': 'Middle Name',
    'lbl_0000326': 'Register',
    'lbl_0000327': 'You have successfully registered for the #PAPSI RUN: FortyFOURWARDofHOPE. Kindly check your email for your QR Code and Acknowledgment. Thank you!',
    'lbl_0000328': 'Registration Summary',
    'lbl_0000329': 'View Registrants',
    'lbl_0000330': 'PAPSI Run 2025 Registrants',
    'lbl_0000331': 'Segment',
    'lbl_0000332': 'Branch of Service',
    'lbl_0000333': 'Sponsor Type',
    'lbl_0000334': 'Category',
    'lbl_0000335': 'Distance',
    'lbl_0000336': 'Events',
    'lbl_0000337': 'Click here to review and sign the Event Waiver and Release of Liability',
    'lbl_0000338': 'Waiver Submitted (Click to View/Edit)',
    'lbl_0000339': 'Delete',
    'lbl_0000340': 'Please enter your age to continue with the waiver.',
    'lbl_0000341': 'If the guardian\'s name is not listed, ensure the guardian is registered first before proceeding with the minor\'s registration.',
    'lbl_0000342': 'Event Details',
    'lbl_0000343': 'Cancel',
    'lbl_0000344': 'You may register a maximum of 3 people per batch.',
    'lbl_0000345': 'Thank you for your interest in applying for the EFT for your Patronage Refund and Interest in Share Capital (Dividend).',
    'lbl_0000346': 'However, Electronic Fund Transfer for Dividends scheduled for February 2026 will be postponed until further notice. The application for EFT-Patronage Refund is expected to reopen later this year.',
    'lbl_0000347': 'Kindly wait for further announcements here in the membership portal and through our official channels.',
    'lbl_0000348': 'We appreciate your patience and understanding.',
    'lbl_0000349': 'OK',
    'lbl_0000350': 'Civilian',
    'lbl_0000351': 'Election Policy',
    'lbl_0000352': 'Already Registered',
    'lbl_0000353': '44th Annual Regular General Assembly Meeting And Election',
    'lbl_0000354': 'View Event',
    'lbl_0000355': 'View Schedules',
    'lbl_0000356': 'Registration starts on',
    'lbl_0000357': 'Registration ends on',
    'lbl_0000358': 'Voting starts on',
    'lbl_0000359': 'Voting ends on',
    'lbl_0000360': 'Notice',
    'lbl_0000361': 'Please select eight (8) candidates for the Board of Directors position.',
    'lbl_0000362': '3 - Officer',
    'lbl_0000363': '3 - Enlisted Personnel',
    'lbl_0000364': '2 - Civilian',
    'lbl_0000365': 'Please select two (2) candidates for the Audit Committee position.',
    'lbl_0000366': '2 - At Large',
    'lbl_0000367': 'Please select one (1) candidate for the Election Committee position.',
    'lbl_0000368': '1 - Civilian',
    'lbl_0000369': 'Vote Limit Reached',
    'lbl_0000370': 'You have already selected the maximum number of candidates for this category. Please deselect a candidate and select again.',
    'lbl_0000371': 'Enter the One-Time Password (OTP) sent to your mobile number or email address.',
    'lbl_0000372': 'Validate',
    'lbl_0000373': 'Confirm your votes',
    'lbl_0000374': 'Please check your votes before submitting them.',
    'lbl_0000375': 'Already voted',
    'lbl_0000376': 'You have already selected the maximum number of candidates for the',
    'lbl_0000377': 'category',
    'lbl_0000378': 'Please deselect a candidate and select again.',
    'lbl_0000379': 'Officer',
    'lbl_0000380': 'Enlisted Personnel',
    'lbl_0000381': 'Civilian',
    'lbl_0000382': 'Not yet started',
    'lbl_0000383': 'No Events Yet',
    'lbl_0000384': 'We don\'t have any events at the moment, but new ones are coming soon. Stay tuned, mga Ka-May-Ari!',
    'lbl_0000385': 'Suffix',
    'lbl_0000386': 'IDs Presented',
    'lbl_0000387': 'Select an ID',
    'lbl_0000388': 'ID Number',
    'lbl_0000389': 'ID Expiry Date',
    'lbl_0000390': 'Place of Birth',
    'lbl_0000391': 'Nationality',
    'lbl_0000392': '(please specify)',
    'lbl_0000393': 'House No.',
    'lbl_0000394': 'Street',
    'lbl_0000395': 'Brgy, Subdivision',
    'lbl_0000396': 'Province',
    'lbl_0000397': 'Municipality',
    'lbl_0000398': 'Country',
    'lbl_0000399': 'ZIP Code',
    'lbl_0000400': 'Years of Residency',
    'lbl_0000401': 'Present Address',
    'lbl_0000402': 'Permanent Address',
    'lbl_0000404': 'Contact Information',
    'lbl_0000405': 'Telephone Number Format',
    'lbl_0000406': 'Other Social Media Account',
}